import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'next-i18next'
import Head from 'next/head'
import {
  defaultGetStaticPaths,
  getLocaleFromContext
} from '../../utils/staticGeneration'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { GetStaticProps, NextPage } from 'next'

// Default static site generation.
export const getStaticPaths = defaultGetStaticPaths
export const getStaticProps: GetStaticProps = async (context) => ({
  props: {
    ...(await serverSideTranslations(getLocaleFromContext(context), ['common']))
  }
})

const useStyles = makeStyles((theme) => ({
  root: {},
  container: {
    minHeight: '40vh',
    margin: theme.spacing(10, 3, 8, 3),
    maxWidth: '600px',
    color: theme.palette.primary.main,
    textAlign: 'center'
  },
  heading: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(3)
  },
  p: {
    lineHeight: 1.5,
    textAlign: 'left',
    whiteSpace: 'pre-line',
    fontSize: '1.2rem'
  }
}))

const ContactPage: NextPage = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  return (
    <>
      <Head>
        <title>{t('Contact information')} - Live Klassisk</title>
        <meta
          name='description'
          content={t(
            'Do you have any questions about Live Klassisk or classical music, concerts, festivals, ensembles and venues in Scandinavia? Do not hesitate to contact us!'
          )}
        />
      </Head>
      <Grid container className={classes.root} justifyContent='center'>
        <Grid className={classes.container}>
          <Typography variant='h2' className={classes.heading}>
            {t('Contact information')}
          </Typography>
          <Typography variant='body1' className={classes.p}>
            {t(
              'Do you have questions for Live Klassisk? Contact one of our departments in Denmark, Sweden or Norway by phone or e-mail. We will return your requests within 24 hours.\n\nLive Klassisk Denmark - info@liveklassisk.dk / +45 2241 4168\nLive Klassisk Sverige - info@liveklassisk.se / +45 2241 4168\nLive Klassisk Norge - info@liveklassisk.no / +47 986 70 803\n\nShould you notice any misinformation and/or misuse of the concert calendar, please contact us as soon as possible.\n\nTo create concerts on Live Klassisk you must request to become an organizer. You find this under ’Organizer login’. Please be aware that you must be able to prove that you arrange concerts with professional musicians and that this is a calendar for concerts with primarily classical music. When you have been approved by the administrators you are free to create and edit concerts. Live Klassisk reserves the right to delete or edit unwanted content even efter a user has been approved.\n\nShould you experience any problems with concert creation, user authentication etc., please contact us by phone or e-mail.'
            )}
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}

export default ContactPage
